import { useLocaleFormatter } from '@casops/shared/hooks/useLocaleFormatter';
import { SafetyAlertModel } from '@casops/store/apis/personnelSafetyApi';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './SafetyAlertHeader.module.scss';
import { SafetyAlertTitle } from '../title/SafetyAlertTitle';
import Skeleton from 'react-loading-skeleton';
import SafetyAlertAcknowledgedCellRenderer from '@casops/components/tables/cells/safety-alert-status/SafetyAlertStatusCellRenderer';

interface SafetyAlertHeaderProps {
  model?: SafetyAlertModel;
}

export const SafetyAlertHeader = ({ model }: SafetyAlertHeaderProps): ReactElement => {
  const { t } = useTranslation();
  const { showTimeAndDateFromIso } = useLocaleFormatter();

  return (
    <div className={styles.header}>
      <SafetyAlertTitle model={model} />
      <div className={styles.summary}>
        {model ? (
          <>
            <span className={styles.status}>
              <SafetyAlertAcknowledgedCellRenderer value={model.ack} size="large" />
            </span>
            <span className={styles.text}>{showTimeAndDateFromIso(model.ts)}</span>
            <span className={styles.text}>{`${t('Fields.PPUID')} ${model.did}`}</span>
          </>
        ) : (
          <>
            <Skeleton width={150} height={22} />
            <Skeleton width={100} height={22} />
            <Skeleton width={100} height={22} />
          </>
        )}
      </div>
    </div>
  );
};
